if (!Object.hasOwn) {
    Object.hasOwn = (object, property) => Object.prototype.hasOwnProperty.call(object, property)
}

if (!Array.prototype.at) {
    Object.defineProperty(Array.prototype, 'at', {
        value: function at(index) {
            const length = this.length >>> 0
            if (length === 0) return undefined
            let relativeIndex = Number(index) || 0
            if (relativeIndex < 0) relativeIndex += length
            if (relativeIndex < 0 || relativeIndex >= length) return undefined
            return this[relativeIndex]
        },
        writable: true,
        enumerable: false,
        configurable: true,
    })
}

if (!String.prototype.replaceAll) {
    Object.defineProperty(String.prototype, 'replaceAll', {
        value: function replaceAll(search, replacement) {
            if (search instanceof RegExp) {
                if (!search.global) {
                    throw new TypeError('String.prototype.replaceAll requires a global RegExp')
                }
                return this.replace(search, replacement)
            }
            return this.split(String(search)).join(String(replacement))
        },
        writable: true,
        enumerable: false,
        configurable: true,
    })
}

if (typeof globalThis.structuredClone !== 'function') {
    globalThis.structuredClone = (value) => {
        if (value === undefined) return undefined
        return JSON.parse(JSON.stringify(value))
    }
}

if (typeof globalThis.URLSearchParams !== 'function') {
    class URLSearchParamsPolyfill {
        constructor(init = '') {
            this._params = []
            if (typeof init === 'string') {
                const query = init.startsWith('?') ? init.slice(1) : init
                if (query) {
                    query.split('&').forEach((pair) => {
                        if (!pair) return
                        const [key, value = ''] = pair.split('=')
                        this.append(decodeURIComponent(key), decodeURIComponent(value))
                    })
                }
            } else if (Array.isArray(init)) {
                init.forEach(([key, value]) => this.append(String(key), String(value)))
            } else if (init && typeof init === 'object') {
                Object.keys(init).forEach((key) => this.append(key, String(init[key])))
            }
        }

        append(key, value) {
            this._params.push([String(key), String(value)])
        }

        set(key, value) {
            const k = String(key)
            const v = String(value)
            let found = false
            this._params = this._params.filter(([existingKey]) => {
                const match = existingKey === k
                if (match && !found) {
                    found = true
                    return true
                }
                return !match
            })
            if (found) {
                for (let i = 0; i < this._params.length; i++) {
                    if (this._params[i][0] === k) {
                        this._params[i][1] = v
                        return
                    }
                }
            } else {
                this._params.push([k, v])
            }
        }

        get(key) {
            const k = String(key)
            for (const [existingKey, value] of this._params) {
                if (existingKey === k) return value
            }
            return null
        }

        has(key) {
            const k = String(key)
            return this._params.some(([existingKey]) => existingKey === k)
        }

        delete(key) {
            const k = String(key)
            this._params = this._params.filter(([existingKey]) => existingKey !== k)
        }

        toString() {
            return this._params
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&')
        }
    }

    globalThis.URLSearchParams = URLSearchParamsPolyfill
}
